// Copied from ds/src/app/layouts/Sideblock/Sidebar/Menu/Group/CollapsibleItem/MenuItem.tsx
// Changed: removed react-i18next (use data.title directly), removed Counter badge
import clsx from 'clsx';
import { NavLink } from 'react-router';
import invariant from 'tiny-invariant';

import { useBreakpointsContext } from '@/ds/contexts/breakpoint/context';
import { useSidebarContext } from '@/ds/contexts/sidebar/context';
import type { NavigationTree } from '@/ds/types/navigation';

export function MenuItem({ data }: { data: NavigationTree }) {
  const { path, title } = data;
  const { lgAndDown } = useBreakpointsContext();
  const { close } = useSidebarContext();

  invariant(path, `[MenuItem] Path is required for navigation item`);

  const handleMenuItemClick = () => lgAndDown && close();

  return (
    <div className="relative flex">
      <NavLink
        to={path}
        onClick={handleMenuItemClick}
        className={({ isActive }) =>
          clsx(
            'group min-w-0 flex-1 rounded-md px-3 py-2 font-medium outline-hidden transition-colors ease-in-out',
            isActive
              ? 'text-primary-600 dark:text-primary-400'
              : 'dark:text-dark-200 dark:hover:bg-dark-300/10 dark:hover:text-dark-50 dark:focus:bg-dark-300/10 text-gray-800 hover:bg-gray-100 hover:text-gray-950 focus:bg-gray-100 focus:text-gray-950'
          )
        }
      >
        {({ isActive }) => (
          <div
            data-menu-active={isActive}
            className="flex min-w-0 items-center justify-between gap-2.5"
          >
            <div className="flex min-w-0 items-center gap-3">
              <div
                className={clsx(
                  isActive
                    ? 'bg-primary-600 dark:bg-primary-400 opacity-80'
                    : 'opacity-50 transition-all',
                  'size-2 rounded-full border border-current'
                )}
              />
              <span className="truncate">{title}</span>
            </div>
          </div>
        )}
      </NavLink>
    </div>
  );
}
